/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-10-30 10:17:28
 * @LastEditors: hongye
 * @LastEditTime: 2025-10-31 13:52:40
 * @Description: file content
 */
import { defineStore } from 'pinia'
import dataDictionaryService from '@/service/api/dataDictionary'
import { lang } from '@/utils'

interface DictValueListVo {
  dictCode?: string
  dictKey?: string
  dictValue?: string
  dictValueExtra1?: string
  dictValueExtra2?: string
  dictValueExtra3?: string
  dictValueExtra4?: string
  /** @format int64 */
  id?: number
  remark?: string
}


export const useDictValue = defineStore('dictValue', {
  state: () => ({
    /**通用配置 */
    DICT_VALUE: {} as Record<string, DictValueListVo[]>,
  }),
  getters:{
    stationPrefix: state => {
      return (state.DICT_VALUE['STATION_SYSTEM'] || []).find(_ => _.dictKey === 'stationPrefix')?.dictValue || ''
    },
    /** 服务能力 */
    SERVICE_CAPABILITY_DIC: state => {
      return (state.DICT_VALUE['SERVICE_CAPABILITY'] || []).map(_ => ({
          value: _.dictKey || '',
          label: lang(_.dictValueExtra1 || '')
        })).reverse()
    },
    /** 经营类型 */
    businessTypeDic: state => {
      return (state.DICT_VALUE['BUSINESS_TYPE'] || []).map(_ => ({
          value: _.dictKey || '',
          label: lang(_.dictValueExtra1 || '')
        })).reverse()
    },
    /** 服务区域 */
    serviceAreaDic: state => {
      return (state.DICT_VALUE['SERVICE_AREA'] || []).map(_ => ({
          value: _.dictKey || '',
          label: lang(_.dictValueExtra1 || '')
        })).reverse()
    },
    /** 站点渠道 */
    siteChannelDic: state => {
      return (state.DICT_VALUE['SITE_CHANNEL'] || []).map(_ => ({
          value: _.dictKey || '',
          label: _.dictValueExtra1 || ''
        })).reverse()
    },
  },
  actions: {
    GET_DICT_VALUE(dictCode: string) {
      return new Promise((resolve, reject) => {
        dataDictionaryService.getDictValue({ dictCode, size: 99 })
          .then((res) => {
            if (res.code === 1) {
              this.DICT_VALUE[dictCode] =(res.data.records || [])
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    /**
     * 获取数据字典
     * @param data any
     * @returns Promise
     */
    getListDictData(data: any) {
      return new Promise((resolve, reject) => {
        dataDictionaryService.getListDictData(data)
          .then((res) => {
            if (res.code === 1) {
              (res.data || []).forEach((_: { dictCode: string; dictValues: DictValueListVo[] }) => {
                this.DICT_VALUE[_.dictCode] = _.dictValues || []
              })
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    }
  },
  persist: {
    storage: sessionStorage
  }
})
